/**
 * Cache owner tracking — prevents cross-user/cross-team data leakage.
 *
 * Stores {accountId, teamId, uid} in localStorage under a version-agnostic key
 * ('scio-cache-owner') so future versions (scio4+) can also read it.
 *
 * Used by AuthProvider to detect user/team/account changes that require
 * cache invalidation (clearStore + clearPersistedCache).
 */

const CACHE_OWNER_KEY = 'scio-cache-owner';

export interface CacheOwner {
  accountId: string;
  teamId: string;
  uid: string;
}

export function getCacheOwner(): CacheOwner | null {
  try {
    const raw = localStorage.getItem(CACHE_OWNER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setCacheOwnerStorage(owner: CacheOwner): void {
  localStorage.setItem(CACHE_OWNER_KEY, JSON.stringify(owner));
}

export function clearCacheOwnerStorage(): void {
  localStorage.removeItem(CACHE_OWNER_KEY);
}
